import { Link, Route, Routes } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import PostsManager from "./PostsManager";
import AdminNav from "./AdminNav";
import StatsPage from "./StatsPage";
import LogoMark from "../LogoMark";

export default function AdminPage() {
  const { email, signOut } = useAuth();
  return (
    <div className="flex min-h-screen flex-col bg-page font-trirong_light text-gray-800">
      <header className="sticky top-0 z-20 border-b border-hairline bg-header">
        <div className="mx-auto flex max-w-[1180px] items-center justify-between gap-5 px-8 py-[18px]">
          <Link
            to="/admin"
            title="Back to home"
            className="group flex cursor-pointer items-center gap-3 rounded transition-opacity hover:opacity-80
                       focus:outline-none focus:ring-2 focus:ring-lime-600/40"
          >
            <LogoMark className="h-[30px] w-auto -translate-y-[1px]" />
            <span className="whitespace-nowrap font-trirong_reg text-[22px] tracking-[0.015em] text-gray-800 group-hover:text-lime-700">
              New Dawn Counselling
            </span>
          </Link>
          <div className="flex items-center gap-[18px]">
            {email && (
              <span className="hidden text-sm text-gray-600 md:inline">
                {email}
              </span>
            )}
            <button
              type="button"
              onClick={signOut}
              className="rounded-full border border-field px-4 py-1.5 text-sm font-trirong_reg text-lime-700
                         transition-colors hover:border-lime-700 hover:bg-[#fbfdf4] focus:outline-none
                         focus:ring-2 focus:ring-lime-600/40"
            >
              Log out
            </button>
          </div>
        </div>
      </header>

      <main className="mx-auto w-full max-w-[1180px] flex-1 px-8 pb-24 pt-[46px]">
        <AdminNav />
        <Routes>
          <Route path="stats" element={<StatsPage />} />
          <Route path="*" element={<PostsManager />} />
        </Routes>
      </main>
    </div>
  );
}
